<ul class="navbar-nav">
    <li class="nav-item dropdown-appbar d-flex">
      <span class="vertical-line-seperator left">&nbsp;</span>
      <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
         aria-expanded="false">{{ name | async}}</a>
      <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
        <a class="dropdown-item" (click)="signOut()">Sign Out</a>
      </div>
    </li>
  </ul>
  
  